import {ReactElement, RefObject, SetStateAction} from "react";
import {observer} from 'mobx-react';
import Markdown from "../../../utilities/Markdown";

import classNames from "classnames";
import styles from "./styles/MessageBlock.module.scss";
import SlateEditor from "../../../editors/MarkdownEditor";
import {useStores} from "../../../../stores/useStores";

export const MessageBlock = observer((props: {
    editMode: boolean,
    messageRef?: RefObject<HTMLDivElement | null>,
    message?: string,
    setMessage: SetStateAction<any>,
}) => {
    const {userStore} = useStores();

    const messageBlockClassName = classNames({
        [styles.messageBlock]: true,
    });
    const messageContainerClassName = classNames({
        [styles.messageContainer]: true,
    })

    let content: ReactElement | string | undefined = props.message, jsx;
    if (!props.message && userStore.isEditor && !props.editMode) {
        content = "Add some text!"
    }

    if (props.editMode) {
        jsx = <>
            <SlateEditor editorClassName={styles.editor} handleTextChange={v => props.setMessage(v)} value={props.message || ""}/>
        </>
    } else {
        jsx = <div className={messageBlockClassName}>
            <Markdown source={content} withStyles={true}/>
        </div>
    }

    return (
        <div className={messageContainerClassName}>
            {jsx}
        </div>
    );
})
